export const PRODUCT_TYPES = ['Standard', 'Custom'];
export const SERVICE_TYPES = ['Decoration', 'Charge'];
export const PRICING_UNITS = ['PerUnit', 'FixedFee', 'PerKg', 'PerCbm'];
export const LINE_TYPES = ['Product', 'Service', 'Logistics'];
export const CERTIFICATE_SCOPES = ['Supplier', 'Product'];

export const PRODUCT_DOCUMENT_TYPES = [
  'Image', 'Datasheet', 'BrandingTemplate', 'Artwork', 'PackagingSpec', 'ProductionNote', 'TestReport',
];

export const COMPLIANCE_DOCUMENT_TYPES = [
  'TestReport', 'MaterialDeclaration', 'ReachDeclaration',
];
